var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReroll(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3293_49313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 12C15.58 12 12 15.58 12 20C12 24.42 15.58 28 20 28C24.42 28 28 24.42 28 20C28 15.58 24.42 12 20 12ZM24.95 24.95C23.68 26.22 21.93 27 20 27C18.07 27 16.32 26.22 15.05 24.95C13.78 23.68 13 21.93 13 20C13 18.07 13.78 16.32 15.05 15.05C16.32 13.78 18.07 13 20 13C21.93 13 23.68 13.78 24.95 15.05C26.22 16.32 27 18.07 27 20C27 21.93 26.22 23.68 24.95 24.95Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 16C23.22 16 23 16.22 23 16.5V23.5C23 23.78 23.22 24 23.5 24C23.78 24 24 23.78 24 23.5V16.5C24 16.22 23.78 16 23.5 16Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.96 16.3C18.88 16.12 18.7 16 18.5 16C18.3 16 18.12 16.12 18.04 16.3L15.04 23.3C14.93 23.55 15.04 23.85 15.3 23.96C15.55 24.07 15.85 23.96 15.96 23.7L16.69 22H20.32L21.05 23.7C21.16 23.95 21.45 24.07 21.71 23.96C21.96 23.85 22.08 23.56 21.97 23.3L18.97 16.3H18.96ZM17.12 21L18.5 17.77L19.88 21H17.11H17.12Z",
    fill: ""
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3293_49313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReroll);
export default __webpack_public_path__ + "static/media/reroll.ea2364dd2473cf27c0619bffaedba3e5.svg";
export { ForwardRef as ReactComponent };